import styled from "styled-components";
import theme from "../../utils/theme";

export default styled.span`
  ${({ variant }) => theme.text[variant]}
`;
